import { UiKit } from '@datavant/uikit';
import React from 'react';
import { FormBreadcrumbsArray } from '../formkit/types';

export const PageTitle = (props: { title?: string; breadcrumbs?: FormBreadcrumbsArray }): JSX.Element => {
    const numberOfBreadcrumbsOrUndefined = props.breadcrumbs?.length;
    const hasAnyBreadcrumbs = !!numberOfBreadcrumbsOrUndefined;
    return (
        <UiKit.Chakra.VStack align={'stretch'} spacing={UiKit.consistency.halfBuffer}>
            {hasAnyBreadcrumbs && <UiKit.Text.Breadcrumb items={props.breadcrumbs ?? []} />}
            {props.title && <UiKit.Text.Heading3 text={props.title} />}
        </UiKit.Chakra.VStack>
    );
};
